// @spec GHG-STR-005
// @spec GHG-STR-086
/**
 * API client functions for GHG grid regions.
 */

import type { GridRegionListResponse } from '../types';

import { createApiClient } from '@/lib/api-client';

/**
 * Fetch available grid regions.
 *
 * @param getToken - Function to get auth token from Clerk
 * @param organizationId - The organization UUID
 * @param country - Optional country filter
 * @param query - Optional search query
 * @returns List of grid regions with freshness metadata
 */
export async function fetchGridRegions(
  getToken: () => Promise<string | null>,
  organizationId: string,
  country?: string,
  query?: string
): Promise<GridRegionListResponse> {
  const apiClient = createApiClient({
    getAuthToken: getToken,
  });

  const params = new URLSearchParams();
  if (country) {
    params.set('country', country);
  }
  if (query) {
    params.set('query', query);
  }

  const queryString = params.toString();
  const url = `/organizations/${organizationId}/ghg/grid-regions${queryString ? `?${queryString}` : ''}`;

  return apiClient.get<GridRegionListResponse>(url);
}
